import { CircularProgress } from "@mui/material"
import React, { useState, useEffect, useCallback, useRef } from "react"
import Servo from "../services/servo"
import { Autocomplete, TextField } from "@mui/material"
import _each from "lodash/each"
import { InputStyles } from "../utils/styles"
import localforage from "localforage"

let IS = InputStyles()
const propertyAccesor = (rootObj, accesor = "") =>
  accesor.split(".").reduce((obj, prop) => obj?.[prop], rootObj)

const AutocompleteDeluxe = ({
  background,
  nombre,
  dato,
  setDato,
  labelToShow,
  labelProp,
  idProp,
  grouped,
  required = "false",
  filtro = {},
  concat,
  ...props
}) => {
  const [datos, setDatos] = useState([])
  const [search, setSearch] = useState("")
  const [loading, setLoading] = useState(true)
  let InputStyles = IS()

  const filtroStringRef = useRef(JSON.stringify(filtro))

  useEffect(() => {
    const newFiltroString = JSON.stringify(filtro)
    if (newFiltroString !== filtroStringRef.current) {
      filtroStringRef.current = newFiltroString
    }
  }, [filtro])

  const getDatos = useCallback(async () => {
    setLoading(true)
    let queryParams = ""
    const currentFiltro = JSON.parse(filtroStringRef.current)

    if (Object.keys(currentFiltro).length > 0) {
      _each(Object.keys(currentFiltro), (f) => {
        if (
          currentFiltro[f] !== null &&
          currentFiltro[f] !== undefined &&
          currentFiltro[f] !== ""
        ) {
          queryParams += "&" + f + "=" + currentFiltro[f]
        }
      })
    }

    const finalQuery =
      nombre + (queryParams ? "?" + queryParams.substring(1) : "")

    try {
      if (!navigator.onLine) {
        let cached = await localforage.getItem("cache_catalog_" + finalQuery)
        if (cached) {
          setDatos(cached)
        } else {
          setDatos([])
        }
        setLoading(false)
        return
      }

      let res = await Servo.get(finalQuery)
      let fetchedData = Array.isArray(res?.cuerpo?.resultado) ? res.cuerpo.resultado : []
      setDatos(fetchedData)
      
      if (fetchedData.length > 0) {
        await localforage.setItem("cache_catalog_" + finalQuery, fetchedData)
      }
    } catch (e) {
      console.error("Error fetching data for AutocompleteDeluxe:", e)
      let cachedFallback = await localforage.getItem("cache_catalog_" + finalQuery)
      setDatos(cachedFallback ? cachedFallback : [])
    } finally {
      setLoading(false)
    }
  }, [nombre, filtroStringRef])

  useEffect(() => {
    getDatos()
  }, [getDatos])

  return (
    <div style={{ width: "100%" }}>
      {!loading ? (
        <div>
          {required === "true" ? (
            <div
              className={InputStyles.text}
              style={{
                marginBottom: "4px", // CLAVE: Reducir margen
                marginTop: "0" // CLAVE: Eliminar margen
              }}
            >
              <p>{labelToShow}</p>
              <p className={InputStyles.required}>*</p>
            </div>
          ) : (
            <div
              className={InputStyles.text}
              style={{
                marginBottom: "4px", // CLAVE: Reducir margen
                marginTop: "0" // CLAVE: Eliminar margen
              }}
            >
              <p>{labelToShow}</p>
            </div>
          )}
          <div>
            <Autocomplete
              isOptionEqualToValue={(option, value) =>
                option && value && option[idProp] === value?.[idProp]
              }
              sx={{
                width: "100%",
                height: "41px",
                border: "2px solid #C7C7C7",
                backgroundColor: "#F2F2F2",
                borderRadius: "10px",
                "& .MuiOutlinedInput-root": {
                  outline: "none",
                  "& .MuiAutocomplete-endAdornment": {
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    width: "32px"
                  },
                  "& .MuiAutocomplete-input": {
                    padding: "0 45px 0 10px !important",
                    border: "none"
                  }
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  height: "41px",
                  border: "none",
                  borderRadius: "10px"
                },
                "& .MuiFilledInput-root": {
                  border: "none",
                  "& .MuiFilledInput-input": {
                    border: "none",
                    color: "red",
                    padding: "0px !important",
                    borderRadius: "10px"
                  }
                },
                "& div": {
                  border: "none"
                }
              }}
              disablePortal
              id="autocompleteDeluxeVersion-1.1"
              value={dato}
              onChange={(e, v) => setDato(v)}
              options={datos
                .filter(
                  (datoItem) =>
                    datoItem &&
                    datoItem[labelProp] &&
                    String(datoItem[labelProp])
                      .toLowerCase()
                      .trim()
                      .includes(search.toLowerCase().trim())
                )
                .slice(0, 10)}
              getOptionLabel={(option) => {
                const primaryLabel = propertyAccesor(option, labelProp) || ""

                if (concat) {
                  const secondaryLabel = propertyAccesor(option, concat) || ""

                  return secondaryLabel
                    ? `${primaryLabel} / ${secondaryLabel}`
                    : primaryLabel
                }

                return primaryLabel
              }}
              renderInput={(params) => (
                <TextField
                  size="Small"
                  variant="outlined"
                  sx={{
                    fontFamily: "poppins",
                    backgroundColor: background != "" ? background : "#F2F2F2",
                    height: "41px",
                    borderRadius: "7px",
                    "& label": {
                      height: "20px",
                      padding: "0"
                    },
                    "& div": {
                      border: "none",
                      height: "100%",
                      "& .MuiFilledInput-input": {
                        color: "red"
                      },
                      "& input": {
                        padding: "0",
                        height: "100%",
                        fontFamily: "poppins",
                        fontWeight: "500",
                        fontSize: "14px",
                        lineHeight: "10px",
                        letterSpacing: "0.07em",
                        color: "#AAAAAA"
                      }
                    }
                  }}
                  onChange={(e) => {
                    setSearch(e.target.value)
                  }}
                  {...params}
                />
              )}
              {...props}
            />
          </div>
        </div>
      ) : (
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center"
          }}
        >
          <CircularProgress />
        </div>
      )}
    </div>
  )
}

export default AutocompleteDeluxe
